<script lang="ts">
  import type { NavLink } from './types';

  interface Props {
    links: NavLink[];
  }

  const { links }: Props = $props();
</script>

<nav>
  <div class="nav-inner">
    <ul>
      {#each links as link (link.label)}
        <!-- eslint-disable-next-line svelte/no-navigation-without-resolve -->
        <li><a href={'#' + link.id}>{link.label}</a></li>
      {/each}
    </ul>
  </div>
</nav>

<style>
  nav {
    background: rgba(10, 10, 10, 0.95);
    backdrop-filter: blur(10px);
    position: sticky;
    top: 0;
    z-index: 1000;
    border-bottom: 1px solid var(--light-purple);
  }

  .nav-inner {
    display: flex;
    justify-content: center;
  }

  ul {
    display: flex;
    justify-content: center;
    list-style: none;
    margin: 0;
    padding: 0.7rem 1rem;
    gap: 1rem;
  }

  a {
    color: var(--light-purple);
    text-decoration: none;
    text-transform: uppercase;
    font-size: 0.75rem;
    white-space: nowrap;
    letter-spacing: 0.02rem;
    font-weight: 500;
  }

  /* Large mobile */
  @media (min-width: 512px) {
    ul {
      gap: 2rem;
      padding: 1rem;
    }
    a {
      font-size: 1rem;
      letter-spacing: 0.05rem;
    }
  }

  /* Tablet (iPad mini / iPad Air) */
  @media (min-width: 768px) and (max-width: 1023px) {
    ul {
      gap: 2rem;
      padding: 1rem 1.5rem;
    }
    a {
      font-size: 1.1rem;
      letter-spacing: 0.05rem;
    }
  }

  /* iPad Pro and desktop */
  @media (min-width: 1024px) {
    ul {
      gap: 4rem;
      padding: 1.5rem;
    }
    a {
      font-size: 1.5rem;
      letter-spacing: 0.1rem;
    }
  }
</style>
